import { BASE, reconcileAuctionsResponse, axiom } from "../../utils";

export const getAuctionsByProductId = async (abortController, productId) => {
  const sendDate = new Date().getTime();

  try {
    const auctions = await (
      await fetch(BASE + `/auction?nativeProductId=${productId}`, {
        signal: abortController.signal,
        method: "GET",
      })
    ).json();

    await axiom(abortController, {
      action: "getAuctionsByNativeProductId",
      responseLength: JSON.stringify(auctions).length,
      responseTime: new Date().getTime() - sendDate,
      error: null,
    });

    return reconcileAuctionsResponse(auctions);
  } catch (error) {
    console.log(error);
    await axiom(abortController, {
      action: "getAuctionsByNativeProductId",
      responseLength: -1,
      responseTime: new Date().getTime() - sendDate,
      error,
    });
  }
  return {};
};

export const fetchKPIs = async ({ auctionId, params }) => {
  /*
  const response = await (
    await fetch(BASE + "/auction/" + auctionId + "/kpis", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
  ).json();

  return response;
  */
  return {};
};

export const fetchGuard = async ({ auctionId, customerId }) => {
  /*
  try {
    const resp = await (
      await fetch(BASE + "/auction/" + auctionId + "/guard/" + customerId, {
        method: "GET",
      })
    ).json();

    return resp.active_checkout ?? {};
  } catch (e) {
    console.log(e);
  }
  */
  return {};
};
